import React from 'react';
import { ArrowIcon, CheckIcon, ChevronLeftIcon, ChevronRightIcon } from './ui/icons';
export function CoworkingPage() {
  return <>
      <style data-id="element-460">{`div {
}
section {
  box-sizing: border-box;
}
span {
  box-sizing: border-box;
}
h2 {
  box-sizing: border-box;
  font-family: SharpGroteskSemiBold, Arial, Verdana;
  letter-spacing: -0.6px;
  padding: 0px;
}
a {
  box-sizing: border-box;
  font-size: 20px;
  transition-behavior: normal, normal, normal;
  transition-duration: 0.1s, 0.1s, 0.1s;
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition-delay: 0s, 0s, 0s;
  transition-property: transform, box-shadow, background-color;
  cursor: pointer;
  font-family: SharpGroteskMedium, Arial, Verdana;
  font-weight: 400;
  min-height: 60px;
  outline-style: none;
  outline-width: 0px;
  position: relative;
  align-items: center;
  flex-wrap: wrap;
  transform: matrix(1, 0, 0, 1, 0, 0);
  z-index: 1;
  border-radius: 4px;
  text-decoration: none;
}
svg {
  box-sizing: border-box;
}
path {
  box-sizing: border-box;
}
picture {
  box-sizing: border-box;
  display: block;
  min-height: 1px;
  min-width: 1px;
  opacity: 1;
  transition-behavior: normal;
  transition-duration: 0.25s;
  transition-timing-function: ease-in;
  transition-delay: 0s;
  transition-property: opacity;
}
source {
  box-sizing: border-box;
}
img {
  border-top-style: none;
  border-right-style: none;
  border-bottom-style: none;
  border-left-style: none;
  max-width: 100%;
  box-sizing: border-box;
  min-height: 0px;
  min-width: 100%;
  object-fit: cover;
  vertical-align: top;
  bottom: 0px;
  left: 0px;
  right: 0px;
  top: 0px;
  padding: 0px;
  margin: 0px;
}
h3 {
  box-sizing: border-box;
  font-family: SharpGroteskSemiBold, Arial, Verdana;
  font-weight: 400;
  padding: 0px;
  margin: 0px;
}
p {
  box-sizing: border-box;
  font-family: Rubik, Arial, sans-serif;
}
button {
  font-size: 10px;
  line-height: 11.5px;
  overflow-x: visible;
  overflow-y: visible;
  text-transform: none;
  appearance: button;
  box-sizing: border-box;
  cursor: pointer;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-variant-alternates: normal;
  font-variant-position: normal;
  font-variant-emoji: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-optical-sizing: auto;
  font-size-adjust: none;
  font-kerning: auto;
  font-feature-settings: normal;
  font-variation-settings: normal;
  outline-style: none;
  outline-width: 0px;
}
tr {
  box-sizing: border-box;
}
th {
  position: sticky;
  top: 120px;
  line-height: 27px;
  background-color: rgb(102, 175, 255);
  box-sizing: border-box;
  text-align: left;
  color: rgb(0, 0, 0);
  font-family: Rubik, Arial, sans-serif;
  font-size: 18px;
  letter-spacing: 0.3px;
  border-top: 0px none rgb(0, 0, 0);
  border-bottom: 1px solid rgb(0, 0, 0);
}
td {
  box-sizing: border-box;
  text-align: left;
  line-height: 24px;
  font-size: 18px;
  border-top: 0px none rgb(0, 0, 0);
  border-bottom: 0px none rgb(0, 0, 0);
  padding: 25px 10px 25px 10px;
}
`}</style>
      <div style={{
      boxSizing: 'border-box',
      padding: '0px',
      margin: '0px',
      width: '100%',
      backgroundColor: 'rgb(255, 255, 255)',
      color: 'rgb(0, 0, 0)',
      fontSize: '10px',
      lineHeight: '11.5px',
      fontFamily: 'Rubik, Arial, sans-serif'
    }} data-id="element-461">
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-462">
          <section style={{
          backgroundColor: 'rgb(102, 191, 138)',
          marginBottom: '40px',
          width: '1512px',
          backgroundImage: 'linear-gradient(90deg, rgb(102, 191, 138) 80%, rgb(255, 255, 255) 0px)',
          marginRight: '0px',
          padding: '60px 0px 50px 0px'
        }} data-id="element-463">
            <div style={{
            boxSizing: 'border-box',
            width: '1280px',
            maxWidth: '1280px',
            padding: '0px 80px 0px 80px',
            margin: '0px'
          }} data-id="element-464">
              <div style={{
              boxSizing: 'border-box',
              display: 'flex',
              flexWrap: 'wrap',
              padding: '0px',
              margin: '0px -10px 0px -10px'
            }} data-id="element-465">
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                width: '475px',
                flexGrow: '0',
                flexShrink: '0',
                flexBasis: '41.6667%',
                maxWidth: '41.6667%',
                padding: '0px 10px 0px 10px',
                margin: '0px'
              }} data-id="element-466">
                  <h4 style={{
                  boxSizing: 'border-box',
                  fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                  fontWeight: '400',
                  lineHeight: '24px',
                  fontSize: '18px',
                  position: 'relative',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                  bottom: '0px',
                  content: 'normal',
                  height: '49px',
                  width: '455px',
                  left: '0px',
                  padding: '0px 0px 25px 0px',
                  margin: '0px'
                }} data-id="element-467">
                    <span style={{
                    lineHeight: '24px',
                    fontSize: '18px',
                    position: 'absolute',
                    backgroundColor: 'rgb(0, 0, 0)',
                    bottom: '0px',
                    content: '""',
                    height: '2px',
                    width: '355px',
                    left: '0px',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-468"></span>
                    Entra in contatto con una community eterogenea
                  </h4>
                </div>
              </div>
              <div style={{
              boxSizing: 'border-box',
              display: 'flex',
              flexWrap: 'wrap',
              padding: '0px',
              margin: '0px -10px 0px -10px'
            }} data-id="element-469">
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                width: '475px',
                flexGrow: '0',
                flexShrink: '0',
                flexBasis: '41.6667%',
                maxWidth: '41.6667%',
                padding: '0px 10px 0px 10px',
                margin: '0px'
              }} data-id="element-470">
                  <div style={{
                  boxSizing: 'border-box',
                  padding: '0px 40px 0px 0px',
                  margin: '0px'
                }} data-id="element-471">
                    <h2 style={{
                    fontWeight: '400',
                    lineHeight: '62.5px',
                    fontSize: '50px',
                    display: 'block',
                    margin: '40px 0px 30px 0px'
                  }} data-id="element-472">
                      Programma Membership, un nuovo concept di co-working
                    </h2>
                    <div style={{
                    boxSizing: 'border-box',
                    lineHeight: '27px',
                    fontSize: '18px',
                    letterSpacing: '0.3px',
                    padding: '0px',
                    margin: '0px 0px 40px 0px'
                  }} data-id="element-473">
                      The Social Hub Roma offre il co-working come parte
                      integrante del suo programma Membership. Con l'abbonamento
                      avrai accesso ai nostri esclusivi spazi di co-working,
                      alla palestra completamente attrezzata, ai corsi di
                      fitness, al nostro programma di eventi, alle aree dedicate
                      e alla piscina sul tetto: avrai così l'occasione di
                      conoscere la nostra eterogenea community.
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    width: '415px',
                    padding: '0px',
                    margin: '0px 0px 30px 0px'
                  }} data-id="element-474">
                      <a href="/it/roma/membership/" style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(255, 255, 255)',
                      maxWidth: '500px',
                      minWidth: '290px',
                      outlineColor: 'rgb(255, 255, 255)',
                      display: 'inline-flex',
                      textAlign: 'left',
                      border: '0px none rgb(255, 255, 255)',
                      padding: '13px 80px 13px 30px',
                      margin: '0px'
                    }} data-id="element-475">
                        <span style={{
                        lineHeight: '24px',
                        color: 'rgb(255, 255, 255)',
                        fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                        fontSize: '20px',
                        marginBottom: '0px',
                        textOverflow: 'ellipsis',
                        width: '113.906px'
                      }} data-id="element-476">
                          Scopri di più
                        </span>
                        <span style={{
                        alignItems: 'center',
                        display: 'flex',
                        height: '32px',
                        justifyContent: 'center',
                        position: 'absolute',
                        right: '0px',
                        top: '30px',
                        transform: 'matrix(1, 0, 0, 1, -30, -16)',
                        transitionBehavior: 'normal',
                        transitionDuration: '0.1s',
                        transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                        transitionDelay: '0s',
                        transitionProperty: 'transform',
                        width: '32px'
                      }} data-id="element-477">
                          <ArrowIcon style={{
                          height: '32px',
                          width: '32px',
                          fill: 'rgb(255, 255, 255)'
                        }} data-id="element-478" />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                width: '570px',
                flexGrow: '0',
                flexShrink: '0',
                flexBasis: '50%',
                maxWidth: '50%',
                padding: '0px 10px 0px 10px',
                margin: '0px 0px 0px 95px'
              }} data-id="element-479">
                  <div style={{
                  boxSizing: 'border-box',
                  display: 'block',
                  position: 'relative',
                  width: '630px',
                  padding: '0px',
                  margin: '0px -80px 0px 0px'
                }} data-id="element-480">
                    <div style={{
                    boxSizing: 'border-box',
                    height: '472.5px',
                    backgroundColor: 'rgb(164, 164, 165)',
                    position: 'relative',
                    padding: '0px 0px 472.5px 0px',
                    margin: '0px'
                  }} data-id="element-481">
                      <picture role="button" tabIndex={0} style={{
                      bottom: '0px',
                      height: '472.5px',
                      left: '0px',
                      position: 'absolute',
                      right: '0px',
                      top: '0px',
                      width: '630px'
                    }} data-id="element-482">
                        <source srcSet="/48d6b0/contentassets/0cd0eba812744ab39f433bf1b1f870b8/coworking_promo.jpg?width=630&height=473&rmode=crop&scale=both&quality=90" media="(min-width:1025px)" style={{}} data-id="element-483"></source>
                        <source srcSet="/48d6b0/contentassets/0cd0eba812744ab39f433bf1b1f870b8/coworking_promo.jpg?width=500&height=375&rmode=crop&scale=both&quality=90" media="(min-width:768px)" style={{}} data-id="element-484"></source>
                        <source srcSet="/48d6b0/contentassets/0cd0eba812744ab39f433bf1b1f870b8/coworking_promo.jpg?width=706&height=530&rmode=crop&scale=both&quality=90" media="(min-width:481px)" style={{}} data-id="element-485"></source>
                        <img src="/48d6b0/contentassets/0cd0eba812744ab39f433bf1b1f870b8/coworking_promo.jpg?width=480&height=360&rmode=crop&scale=both&quality=90" alt="" style={{
                        height: '472.5px',
                        width: '630px',
                        position: 'absolute'
                      }} data-id="element-486"></img>
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-487">
          <div style={{
          boxSizing: 'border-box',
          width: '1280px',
          maxWidth: '1280px',
          padding: '0px 80px 0px 80px',
          margin: '0px 116px 0px 116px'
        }} data-id="element-488">
            <section style={{
            marginBottom: '80px'
          }} data-id="element-489">
              <div style={{
              boxSizing: 'border-box',
              display: 'flex',
              flexWrap: 'wrap',
              padding: '0px',
              margin: '0px -10px 0px -10px'
            }} data-id="element-490">
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                width: '380px',
                flexGrow: '0',
                flexShrink: '0',
                flexBasis: '33.3333%',
                maxWidth: '33.3333%',
                padding: '0px 10px 0px 10px',
                margin: '0px'
              }} data-id="element-491">
                  <h3 style={{
                  lineHeight: '50px',
                  fontSize: '40px',
                  letterSpacing: '-0.6px',
                  textAlign: 'left'
                }} data-id="element-492">
                    Uno spazio di lavoro per tutte le tue esigenze
                  </h3>
                </div>
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                width: '665px',
                flexGrow: '0',
                flexShrink: '0',
                flexBasis: '58.3333%',
                maxWidth: '58.3333%',
                padding: '0px 10px 0px 10px',
                margin: '0px 0px 0px 95px'
              }} data-id="element-493">
                  <section style={{
                  marginBottom: '40px',
                  overflowX: 'auto',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                  textAlign: 'left',
                  paddingTop: '20px'
                }} data-id="element-494">
                    <p style={{
                    color: 'rgb(103, 104, 106)',
                    fontSize: '18px',
                    lineHeight: '27px',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-495">
                      Nella nostra community troverai persone ricche di grinta e
                      determinazione, da menti creative a start-up ambiziose,
                      che lavorano (e si divertono) intensamente, per creare una
                      società migliore. Per soddisfare le tue esigenze,
                      arricchisci il tuo programma Membership aggiungendo una
                      scrivania dedicata o un ufficio privato.
                    </p>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-496">
          <section style={{
          cursor: 'grab',
          marginBottom: '40px',
          position: 'relative',
          alignItems: 'center',
          display: 'flex'
        }} data-id="element-497">
            <div style={{
            boxSizing: 'border-box',
            position: 'relative',
            overflowX: 'hidden',
            overflowY: 'hidden',
            listStylePosition: 'outside',
            listStyleImage: 'none',
            listStyleType: 'none',
            zIndex: '1',
            padding: '0px',
            margin: '0px'
          }} data-id="element-498">
              <div style={{
              boxSizing: 'content-box',
              position: 'relative',
              width: '1512px',
              height: '981px',
              zIndex: '1',
              display: 'flex',
              transitionProperty: 'transform',
              transform: 'matrix(1, 0, 0, 1, -1909, 0)',
              transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
              transitionDuration: '0s',
              padding: '0px',
              margin: '0px'
            }} data-id="element-499">
                <div style={{
                boxSizing: 'border-box',
                flexShrink: '0',
                width: '740px',
                transform: 'matrix(0.8, 0, 0, 0.8, 0, 0)',
                transitionBehavior: 'normal',
                transitionDuration: '0.2s',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: '0s',
                transitionProperty: 'transform',
                padding: '0px',
                margin: '0px 25px 0px 0px'
              }} data-id="element-500">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '740px',
                  width: '740px',
                  zIndex: '1',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-501">
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(225, 225, 225)',
                    display: 'block',
                    fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    position: 'relative',
                    top: '15px',
                    transitionBehavior: 'normal',
                    transitionDuration: '0.6s',
                    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                    transitionDelay: '0s',
                    transitionProperty: 'top',
                    zIndex: '1',
                    borderRadius: '6px',
                    padding: '4px 10px 6px 10px',
                    margin: '0px'
                  }} data-id="element-502">
                      Da 121 € al mese (IVA inclusa)
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '740px',
                    borderBottomColor: 'rgb(0, 0, 0)',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-503">
                      <picture style={{
                      backgroundColor: 'rgb(164, 164, 165)',
                      height: '407px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      paddingTop: '407px',
                      position: 'relative',
                      width: '740px'
                    }} data-id="element-504">
                        <source srcSet="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:1025px)" style={{}} data-id="element-505"></source>
                        <source srcSet="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:768px)" style={{}} data-id="element-506"></source>
                        <source srcSet="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=767&height=425&rmode=crop&scale=crop&quality=90" media="(min-width:481px)" style={{}} data-id="element-507"></source>
                        <img src="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=315&height=175&rmode=crop&scale=crop&quality=90" alt="" style={{
                        height: '407px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-508"></img>
                        <span style={{
                        display: 'block',
                        minHeight: '0px',
                        minWidth: '0px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        height: '407px',
                        overflowX: 'visible',
                        overflowY: 'visible',
                        paddingTop: '0px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-509"></span>
                      </picture>
                      <h2 style={{
                      fontWeight: '800',
                      lineHeight: '50px',
                      fontSize: '40px',
                      bottom: '35px',
                      color: 'rgb(255, 255, 255)',
                      left: '65px',
                      position: 'absolute',
                      margin: '0px'
                    }} data-id="element-510">
                        Membership
                      </h2>
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    fontSize: '18px',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'relative',
                    width: '740px',
                    content: 'normal',
                    display: 'block',
                    height: '544px',
                    left: '0px',
                    top: '0px',
                    transform: 'none',
                    zIndex: 'auto',
                    transitionBehavior: 'normal, normal',
                    transitionDuration: '0.2s, 0.2s',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    transitionDelay: '0s, 0s',
                    transitionProperty: 'background-color, border-color',
                    borderLeft: '1px solid rgb(164, 164, 165)',
                    borderRight: '1px solid rgb(164, 164, 165)',
                    borderBottom: '1px solid rgb(164, 164, 165)',
                    padding: '40px 65px 30px 65px',
                    margin: '0px'
                  }} data-id="element-511">
                      <span style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      fontSize: '18px',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      position: 'absolute',
                      width: '30px',
                      content: '" "',
                      display: 'block',
                      height: '30px',
                      left: '54px',
                      top: '-15px',
                      transform: 'matrix(0.744165, 0.670049, -0.744165, 0.670049, 0, 0)',
                      zIndex: '1',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'all',
                      borderLeft: '0px none rgb(0, 0, 0)',
                      borderRight: '0px none rgb(0, 0, 0)',
                      borderBottom: '0px none rgb(0, 0, 0)',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-512"></span>
                      <p style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '22px',
                      lineHeight: '33px',
                      padding: '0px',
                      margin: '0px 0px 20px 0px'
                    }} data-id="element-513">
                        Entra facilmente in contatto con altre persone come te
                        grazie all'accesso agli spazi riservati, agli eventi
                        della community e ai lounge dedicati, coniugando
                        co-working, networking, workout e molto altro.{' '}
                      </p>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexWrap: 'wrap',
                      borderBottom: '1px solid rgb(0, 0, 0)',
                      padding: '0px 0px 20px 0px',
                      margin: '0px 0px 30px 0px'
                    }} data-id="element-514">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-515">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-516" />
                          <span style={{}} data-id="element-517">Accesso 24h/7</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-518">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-519" />
                          <span style={{}} data-id="element-520">
                            Siediti dove vuoi negli spazi di lavoro o in quelli
                            dedicati alla socialità
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-521">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-522" />
                          <span style={{}} data-id="element-523">Tè, caffè e acqua illimitati</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-524">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-525" />
                          <span style={{}} data-id="element-526">
                            Eventi e attività della comunità
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-527">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-528" />
                          <span style={{}} data-id="element-529">Porta 1 ospite</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-530">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-531" />
                          <span style={{}} data-id="element-532">
                            Entra in contatto con la nostra vasta comunità
                          </span>
                        </div>
                      </div>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-533">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-534">
                          <div style={{
                          boxSizing: 'border-box',
                          padding: '0px',
                          margin: '0px'
                        }} data-id="element-535"></div>
                        </div>
                        <a href="/it/forms/co-working/pacchetti/" style={{
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        color: 'rgb(0, 0, 0)',
                        maxWidth: 'none',
                        minWidth: '0px',
                        outlineColor: 'rgb(0, 0, 0)',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgb(0, 0, 0)',
                        padding: '13px 30px 13px 30px',
                        margin: '0px 0px 0px 355.297px'
                      }} data-id="element-536">
                          <span style={{
                          lineHeight: '24px',
                          color: 'rgb(0, 0, 0)',
                          fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                          fontSize: '20px',
                          marginBottom: '0px',
                          textOverflow: 'ellipsis',
                          width: '190.703px'
                        }} data-id="element-537">
                            Richiedi informazioni
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{
                boxSizing: 'border-box',
                flexShrink: '0',
                width: '740px',
                transform: 'matrix(0.8, 0, 0, 0.8, 0, 0)',
                transitionBehavior: 'normal',
                transitionDuration: '0.2s',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: '0s',
                transitionProperty: 'transform',
                padding: '0px',
                margin: '0px 25px 0px 0px'
              }} data-id="element-538">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '740px',
                  width: '740px',
                  zIndex: '1',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-539">
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(225, 225, 225)',
                    display: 'block',
                    fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    position: 'relative',
                    top: '15px',
                    transitionBehavior: 'normal',
                    transitionDuration: '0.6s',
                    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                    transitionDelay: '0s',
                    transitionProperty: 'top',
                    zIndex: '1',
                    borderRadius: '6px',
                    padding: '4px 10px 6px 10px',
                    margin: '0px'
                  }} data-id="element-540">
                      398 € al mese (IVA escl.)
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '740px',
                    borderBottomColor: 'rgb(0, 0, 0)',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-541">
                      <picture style={{
                      backgroundColor: 'rgb(164, 164, 165)',
                      height: '407px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      paddingTop: '407px',
                      position: 'relative',
                      width: '740px'
                    }} data-id="element-542">
                        <source srcSet="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:1025px)" style={{}} data-id="element-543"></source>
                        <source srcSet="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:768px)" style={{}} data-id="element-544"></source>
                        <source srcSet="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=767&height=425&rmode=crop&scale=crop&quality=90" media="(min-width:481px)" style={{}} data-id="element-545"></source>
                        <img src="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=315&height=175&rmode=crop&scale=crop&quality=90" alt="" style={{
                        height: '407px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-546"></img>
                        <span style={{
                        display: 'block',
                        minHeight: '0px',
                        minWidth: '0px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        height: '407px',
                        overflowX: 'visible',
                        overflowY: 'visible',
                        paddingTop: '0px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-547"></span>
                      </picture>
                      <h2 style={{
                      fontWeight: '800',
                      lineHeight: '50px',
                      fontSize: '40px',
                      bottom: '35px',
                      color: 'rgb(255, 255, 255)',
                      left: '65px',
                      position: 'absolute',
                      margin: '0px'
                    }} data-id="element-548">
                        Ufficio privato
                      </h2>
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    fontSize: '18px',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'relative',
                    width: '740px',
                    content: 'normal',
                    display: 'block',
                    height: '507px',
                    left: '0px',
                    top: '0px',
                    transform: 'none',
                    zIndex: 'auto',
                    transitionBehavior: 'normal, normal',
                    transitionDuration: '0.2s, 0.2s',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    transitionDelay: '0s, 0s',
                    transitionProperty: 'background-color, border-color',
                    borderLeft: '1px solid rgb(164, 164, 165)',
                    borderRight: '1px solid rgb(164, 164, 165)',
                    borderBottom: '1px solid rgb(164, 164, 165)',
                    padding: '40px 65px 30px 65px',
                    margin: '0px'
                  }} data-id="element-549">
                      <span style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      fontSize: '18px',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      position: 'absolute',
                      width: '30px',
                      content: '" "',
                      display: 'block',
                      height: '30px',
                      left: '54px',
                      top: '-15px',
                      transform: 'matrix(0.744165, 0.670049, -0.744165, 0.670049, 0, 0)',
                      zIndex: '1',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'all',
                      borderLeft: '0px none rgb(0, 0, 0)',
                      borderRight: '0px none rgb(0, 0, 0)',
                      borderBottom: '0px none rgb(0, 0, 0)',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-550"></span>
                      <p style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '22px',
                      lineHeight: '33px',
                      padding: '0px',
                      margin: '0px 0px 20px 0px'
                    }} data-id="element-551">
                        Se desideri maggiore pace e tranquillità, aggiungi un
                        ufficio privato al tuo programma Membership. Tutti gli
                        uffici sono completamente arredati e puliti con
                        regolarità, così tu e il tuo team potrete concentrarvi
                        solo sul lavoro e approfittare di tutti nostri vantaggi.
                      </p>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexWrap: 'wrap',
                      borderBottom: '1px solid rgb(0, 0, 0)',
                      padding: '0px 0px 20px 0px',
                      margin: '0px 0px 30px 0px'
                    }} data-id="element-552">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-553">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-554" />
                          <span style={{}} data-id="element-555">
                            Ufficio privato completamente arredato
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-556">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-557" />
                          <span style={{}} data-id="element-558">
                            Registrazione dell'attività commerciale
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-559">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-560" />
                          <span style={{}} data-id="element-561">Servizio postale</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-562">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-563" />
                          <span style={{}} data-id="element-564">Accesso 24h/7</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-565">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-566" />
                          <span style={{}} data-id="element-567">Arricchisci il tuo abbonamento</span>
                        </div>
                      </div>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-568">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-569">
                          <div style={{
                          boxSizing: 'border-box',
                          padding: '0px',
                          margin: '0px'
                        }} data-id="element-570"></div>
                        </div>
                        <a href="/it/forms/co-working/pacchetti/" style={{
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        color: 'rgb(0, 0, 0)',
                        maxWidth: 'none',
                        minWidth: '0px',
                        outlineColor: 'rgb(0, 0, 0)',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgb(0, 0, 0)',
                        padding: '13px 30px 13px 30px',
                        margin: '0px 0px 0px 355.297px'
                      }} data-id="element-571">
                          <span style={{
                          lineHeight: '24px',
                          color: 'rgb(0, 0, 0)',
                          fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                          fontSize: '20px',
                          marginBottom: '0px',
                          textOverflow: 'ellipsis',
                          width: '190.703px'
                        }} data-id="element-572">
                            Richiedi informazioni
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{
                boxSizing: 'border-box',
                flexShrink: '0',
                width: '740px',
                transform: 'matrix(0.8, 0, 0, 0.8, 0, 0)',
                transitionBehavior: 'normal',
                transitionDuration: '0.2s',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: '0s',
                transitionProperty: 'transform',
                padding: '0px',
                margin: '0px 25px 0px 0px'
              }} data-id="element-573">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '740px',
                  width: '740px',
                  zIndex: '1',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-574">
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(225, 225, 225)',
                    display: 'block',
                    fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    position: 'absolute',
                    top: '-15px',
                    transitionBehavior: 'normal',
                    transitionDuration: '0.6s',
                    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                    transitionDelay: '0s',
                    transitionProperty: 'top',
                    zIndex: '1',
                    right: '15px',
                    borderRadius: '6px',
                    padding: '4px 10px 6px 10px',
                    margin: '0px'
                  }} data-id="element-575">
                      350 € al mese (IVA esclusa)
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '740px',
                    borderBottomColor: 'rgb(0, 0, 0)',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-576">
                      <picture style={{
                      backgroundColor: 'rgb(164, 164, 165)',
                      height: '407px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      paddingTop: '407px',
                      position: 'relative',
                      width: '740px'
                    }} data-id="element-577">
                        <source srcSet="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:1025px)" style={{}} data-id="element-578"></source>
                        <source srcSet="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:768px)" style={{}} data-id="element-579"></source>
                        <source srcSet="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=767&height=425&rmode=crop&scale=crop&quality=90" media="(min-width:481px)" style={{}} data-id="element-580"></source>
                        <img src="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=315&height=175&rmode=crop&scale=crop&quality=90" alt="" style={{
                        height: '407px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-581"></img>
                        <span style={{
                        display: 'block',
                        minHeight: '0px',
                        minWidth: '0px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        height: '407px',
                        overflowX: 'visible',
                        overflowY: 'visible',
                        paddingTop: '0px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-582"></span>
                      </picture>
                      <h2 style={{
                      fontWeight: '800',
                      lineHeight: '50px',
                      fontSize: '40px',
                      bottom: '35px',
                      color: 'rgb(255, 255, 255)',
                      left: '65px',
                      position: 'absolute',
                      margin: '0px'
                    }} data-id="element-583">
                        Scrivania dedicata
                      </h2>
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    fontSize: '18px',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'relative',
                    width: '740px',
                    content: 'normal',
                    display: 'block',
                    height: '507px',
                    left: '0px',
                    top: '0px',
                    transform: 'none',
                    zIndex: 'auto',
                    transitionBehavior: 'normal, normal',
                    transitionDuration: '0.2s, 0.2s',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    transitionDelay: '0s, 0s',
                    transitionProperty: 'background-color, border-color',
                    borderLeft: '1px solid rgb(164, 164, 165)',
                    borderRight: '1px solid rgb(164, 164, 165)',
                    borderBottom: '1px solid rgb(164, 164, 165)',
                    padding: '40px 65px 30px 65px',
                    margin: '0px'
                  }} data-id="element-584">
                      <span style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      fontSize: '18px',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      position: 'absolute',
                      width: '30px',
                      content: '" "',
                      display: 'block',
                      height: '30px',
                      left: '54px',
                      top: '-15px',
                      transform: 'matrix(0.744165, 0.670049, -0.744165, 0.670049, 0, 0)',
                      zIndex: '1',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'all',
                      borderLeft: '0px none rgb(0, 0, 0)',
                      borderRight: '0px none rgb(0, 0, 0)',
                      borderBottom: '0px none rgb(0, 0, 0)',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-585"></span>
                      <p style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '22px',
                      lineHeight: '33px',
                      padding: '0px',
                      margin: '0px 0px 20px 0px'
                    }} data-id="element-586">
                        Hai bisogno di uno spazio tutto per te? Sfrutta i
                        vantaggi di una scrivania fissa e una sedia ergonomica
                        con la nostra scrivania dedicata, estendendo la tua
                        Membership. Personalizza il tuo ambiente di lavoro in
                        base alle tue esigenze.
                      </p>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexWrap: 'wrap',
                      borderBottom: '1px solid rgb(0, 0, 0)',
                      padding: '0px 0px 20px 0px',
                      margin: '0px 0px 30px 0px'
                    }} data-id="element-587">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-588">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-589" />
                          <span style={{}} data-id="element-590">Accesso 24h/7</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-591">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-592" />
                          <span style={{}} data-id="element-593">
                            Scrivania, sedia ergonomica e armadietto
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-594">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-595" />
                          <span style={{}} data-id="element-596">Armadietto privato</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-597">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-598" />
                          <span style={{}} data-id="element-599">Servizio postale</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-600">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-601" />
                          <span style={{}} data-id="element-602">Arricchisci il tuo abbonamento</span>
                        </div>
                      </div>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-603">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-604">
                          <div style={{
                          boxSizing: 'border-box',
                          padding: '0px',
                          margin: '0px'
                        }} data-id="element-605"></div>
                        </div>
                        <a href="/it/forms/co-working/pacchetti/" style={{
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        color: 'rgb(0, 0, 0)',
                        maxWidth: 'none',
                        minWidth: '0px',
                        outlineColor: 'rgb(0, 0, 0)',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgb(0, 0, 0)',
                        padding: '13px 30px 13px 30px',
                        margin: '0px 0px 0px 355.297px'
                      }} data-id="element-606">
                          <span style={{
                          lineHeight: '24px',
                          color: 'rgb(0, 0, 0)',
                          fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                          fontSize: '20px',
                          marginBottom: '0px',
                          textOverflow: 'ellipsis',
                          width: '190.703px'
                        }} data-id="element-607">
                            Richiedi informazioni
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{
                boxSizing: 'border-box',
                flexShrink: '0',
                width: '740px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                transitionBehavior: 'normal',
                transitionDuration: '0.2s',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: '0s',
                transitionProperty: 'transform',
                padding: '0px',
                margin: '0px 25px 0px 0px'
              }} data-id="element-608">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '740px',
                  width: '740px',
                  zIndex: '1',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-609">
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(225, 225, 225)',
                    display: 'block',
                    fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    position: 'relative',
                    top: '15px',
                    transitionBehavior: 'normal',
                    transitionDuration: '0.6s',
                    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                    transitionDelay: '0s',
                    transitionProperty: 'top',
                    zIndex: '1',
                    borderRadius: '6px',
                    padding: '4px 10px 6px 10px',
                    margin: '0px'
                  }} data-id="element-610">
                      Da 121 € al mese (IVA inclusa)
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '740px',
                    borderBottomColor: 'rgb(0, 0, 0)',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-611">
                      <picture style={{
                      backgroundColor: 'rgb(164, 164, 165)',
                      height: '407px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      paddingTop: '407px',
                      position: 'relative',
                      width: '740px'
                    }} data-id="element-612">
                        <source srcSet="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:1025px)" style={{}} data-id="element-613"></source>
                        <source srcSet="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:768px)" style={{}} data-id="element-614"></source>
                        <source srcSet="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=767&height=425&rmode=crop&scale=crop&quality=90" media="(min-width:481px)" style={{}} data-id="element-615"></source>
                        <img src="/49cb5d/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_pantry_membership.jpg?width=315&height=175&rmode=crop&scale=crop&quality=90" alt="" style={{
                        height: '407px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-616"></img>
                        <span style={{
                        display: 'block',
                        minHeight: '0px',
                        minWidth: '0px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        height: '407px',
                        overflowX: 'visible',
                        overflowY: 'visible',
                        paddingTop: '0px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-617"></span>
                      </picture>
                      <h2 style={{
                      fontWeight: '800',
                      lineHeight: '50px',
                      fontSize: '40px',
                      bottom: '35px',
                      color: 'rgb(255, 255, 255)',
                      left: '65px',
                      position: 'absolute',
                      margin: '0px'
                    }} data-id="element-618">
                        Membership
                      </h2>
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(239, 239, 240)',
                    color: 'rgb(0, 0, 0)',
                    fontSize: '18px',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'relative',
                    width: '740px',
                    content: 'normal',
                    display: 'block',
                    height: '544px',
                    left: '0px',
                    top: '0px',
                    transform: 'none',
                    zIndex: 'auto',
                    transitionBehavior: 'normal, normal',
                    transitionDuration: '0.2s, 0.2s',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    transitionDelay: '0s, 0s',
                    transitionProperty: 'background-color, border-color',
                    borderTopColor: 'rgba(255, 255, 255, 0)',
                    borderLeft: '1px solid rgba(255, 255, 255, 0)',
                    borderRight: '1px solid rgba(255, 255, 255, 0)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0)',
                    padding: '40px 65px 30px 65px',
                    margin: '0px'
                  }} data-id="element-619">
                      <span style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      fontSize: '18px',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      position: 'absolute',
                      width: '30px',
                      content: '" "',
                      display: 'block',
                      height: '30px',
                      left: '54px',
                      top: '-15px',
                      transform: 'matrix(0.744165, 0.670049, -0.744165, 0.670049, 0, 0)',
                      zIndex: '1',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'all',
                      borderTopColor: 'rgb(0, 0, 0)',
                      borderLeft: '0px none rgb(0, 0, 0)',
                      borderRight: '0px none rgb(0, 0, 0)',
                      borderBottom: '0px none rgb(0, 0, 0)',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-620"></span>
                      <p style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '22px',
                      lineHeight: '33px',
                      padding: '0px',
                      margin: '0px 0px 20px 0px'
                    }} data-id="element-621">
                        Entra facilmente in contatto con altre persone come te
                        grazie all'accesso agli spazi riservati, agli eventi
                        della community e ai lounge dedicati, coniugando
                        co-working, networking, workout e molto altro.{' '}
                      </p>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexWrap: 'wrap',
                      borderBottom: '1px solid rgb(0, 0, 0)',
                      padding: '0px 0px 20px 0px',
                      margin: '0px 0px 30px 0px'
                    }} data-id="element-622">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-623">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-624" />
                          <span style={{}} data-id="element-625">Accesso 24h/7</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-626">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-627" />
                          <span style={{}} data-id="element-628">
                            Siediti dove vuoi negli spazi di lavoro o in quelli
                            dedicati alla socialità
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-629">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-630" />
                          <span style={{}} data-id="element-631">Tè, caffè e acqua illimitati</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-632">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-633" />
                          <span style={{}} data-id="element-634">
                            Eventi e attività della comunità
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-635">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-636" />
                          <span style={{}} data-id="element-637">Porta 1 ospite</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-638">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-639" />
                          <span style={{}} data-id="element-640">
                            Entra in contatto con la nostra vasta comunità
                          </span>
                        </div>
                      </div>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-641">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-642">
                          <div style={{
                          boxSizing: 'border-box',
                          padding: '0px',
                          margin: '0px'
                        }} data-id="element-643"></div>
                        </div>
                        <a href="/it/forms/co-working/pacchetti/" style={{
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        color: 'rgb(0, 0, 0)',
                        maxWidth: 'none',
                        minWidth: '0px',
                        outlineColor: 'rgb(0, 0, 0)',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgb(0, 0, 0)',
                        padding: '13px 30px 13px 30px',
                        margin: '0px 0px 0px 355.297px'
                      }} data-id="element-644">
                          <span style={{
                          lineHeight: '24px',
                          color: 'rgb(0, 0, 0)',
                          fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                          fontSize: '20px',
                          marginBottom: '0px',
                          textOverflow: 'ellipsis',
                          width: '190.703px'
                        }} data-id="element-645">
                            Richiedi informazioni
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{
                boxSizing: 'border-box',
                flexShrink: '0',
                width: '740px',
                transform: 'matrix(0.8, 0, 0, 0.8, 0, 0)',
                transitionBehavior: 'normal',
                transitionDuration: '0.2s',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: '0s',
                transitionProperty: 'transform',
                padding: '0px',
                margin: '0px 25px 0px 0px'
              }} data-id="element-646">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '740px',
                  width: '740px',
                  zIndex: '1',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-647">
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(225, 225, 225)',
                    display: 'block',
                    fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    position: 'absolute',
                    top: '-15px',
                    transitionBehavior: 'normal',
                    transitionDuration: '0.6s',
                    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                    transitionDelay: '0s',
                    transitionProperty: 'top',
                    zIndex: '1',
                    left: '15px',
                    borderRadius: '6px',
                    padding: '4px 10px 6px 10px',
                    margin: '0px'
                  }} data-id="element-648">
                      398 € al mese (IVA escl.)
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '740px',
                    borderBottomColor: 'rgb(0, 0, 0)',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-649">
                      <picture style={{
                      backgroundColor: 'rgb(164, 164, 165)',
                      height: '407px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      paddingTop: '407px',
                      position: 'relative',
                      width: '740px'
                    }} data-id="element-650">
                        <source srcSet="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:1025px)" style={{}} data-id="element-651"></source>
                        <source srcSet="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:768px)" style={{}} data-id="element-652"></source>
                        <source srcSet="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=767&height=425&rmode=crop&scale=crop&quality=90" media="(min-width:481px)" style={{}} data-id="element-653"></source>
                        <img src="/49cba5/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_private_office_off3.jpg?width=315&height=175&rmode=crop&scale=crop&quality=90" alt="" style={{
                        height: '407px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-654"></img>
                        <span style={{
                        display: 'block',
                        minHeight: '0px',
                        minWidth: '0px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        height: '407px',
                        overflowX: 'visible',
                        overflowY: 'visible',
                        paddingTop: '0px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-655"></span>
                      </picture>
                      <h2 style={{
                      fontWeight: '800',
                      lineHeight: '50px',
                      fontSize: '40px',
                      bottom: '35px',
                      color: 'rgb(255, 255, 255)',
                      left: '65px',
                      position: 'absolute',
                      margin: '0px'
                    }} data-id="element-656">
                        Ufficio privato
                      </h2>
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    fontSize: '18px',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'relative',
                    width: '740px',
                    content: 'normal',
                    display: 'block',
                    height: '507px',
                    left: '0px',
                    top: '0px',
                    transform: 'none',
                    zIndex: 'auto',
                    transitionBehavior: 'normal, normal',
                    transitionDuration: '0.2s, 0.2s',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    transitionDelay: '0s, 0s',
                    transitionProperty: 'background-color, border-color',
                    borderLeft: '1px solid rgb(164, 164, 165)',
                    borderRight: '1px solid rgb(164, 164, 165)',
                    borderBottom: '1px solid rgb(164, 164, 165)',
                    padding: '40px 65px 30px 65px',
                    margin: '0px'
                  }} data-id="element-657">
                      <span style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      fontSize: '18px',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      position: 'absolute',
                      width: '30px',
                      content: '" "',
                      display: 'block',
                      height: '30px',
                      left: '54px',
                      top: '-15px',
                      transform: 'matrix(0.744165, 0.670049, -0.744165, 0.670049, 0, 0)',
                      zIndex: '1',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'all',
                      borderLeft: '0px none rgb(0, 0, 0)',
                      borderRight: '0px none rgb(0, 0, 0)',
                      borderBottom: '0px none rgb(0, 0, 0)',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-658"></span>
                      <p style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '22px',
                      lineHeight: '33px',
                      padding: '0px',
                      margin: '0px 0px 20px 0px'
                    }} data-id="element-659">
                        Se desideri maggiore pace e tranquillità, aggiungi un
                        ufficio privato al tuo programma Membership. Tutti gli
                        uffici sono completamente arredati e puliti con
                        regolarità, così tu e il tuo team potrete concentrarvi
                        solo sul lavoro e approfittare di tutti nostri vantaggi.
                      </p>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexWrap: 'wrap',
                      borderBottom: '1px solid rgb(0, 0, 0)',
                      padding: '0px 0px 20px 0px',
                      margin: '0px 0px 30px 0px'
                    }} data-id="element-660">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-661">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-662" />
                          <span style={{}} data-id="element-663">
                            Ufficio privato completamente arredato
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-664">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-665" />
                          <span style={{}} data-id="element-666">
                            Registrazione dell'attività commerciale
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-667">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-668" />
                          <span style={{}} data-id="element-669">Servizio postale</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-670">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-671" />
                          <span style={{}} data-id="element-672">Accesso 24h/7</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-673">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-674" />
                          <span style={{}} data-id="element-675">Arricchisci il tuo abbonamento</span>
                        </div>
                      </div>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-676">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-677">
                          <div style={{
                          boxSizing: 'border-box',
                          padding: '0px',
                          margin: '0px'
                        }} data-id="element-678"></div>
                        </div>
                        <a href="/it/forms/co-working/pacchetti/" style={{
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        color: 'rgb(0, 0, 0)',
                        maxWidth: 'none',
                        minWidth: '0px',
                        outlineColor: 'rgb(0, 0, 0)',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgb(0, 0, 0)',
                        padding: '13px 30px 13px 30px',
                        margin: '0px 0px 0px 355.297px'
                      }} data-id="element-679">
                          <span style={{
                          lineHeight: '24px',
                          color: 'rgb(0, 0, 0)',
                          fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                          fontSize: '20px',
                          marginBottom: '0px',
                          textOverflow: 'ellipsis',
                          width: '190.703px'
                        }} data-id="element-680">
                            Richiedi informazioni
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{
                boxSizing: 'border-box',
                flexShrink: '0',
                width: '740px',
                transform: 'matrix(0.8, 0, 0, 0.8, 0, 0)',
                transitionBehavior: 'normal',
                transitionDuration: '0.2s',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: '0s',
                transitionProperty: 'transform',
                padding: '0px',
                margin: '0px 25px 0px 0px'
              }} data-id="element-681">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  maxWidth: '740px',
                  width: '740px',
                  zIndex: '1',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-682">
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(225, 225, 225)',
                    display: 'block',
                    fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    position: 'relative',
                    top: '15px',
                    transitionBehavior: 'normal',
                    transitionDuration: '0.6s',
                    transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                    transitionDelay: '0s',
                    transitionProperty: 'top',
                    zIndex: '1',
                    borderRadius: '6px',
                    padding: '4px 10px 6px 10px',
                    margin: '0px'
                  }} data-id="element-683">
                      350 € al mese (IVA esclusa)
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '740px',
                    borderBottomColor: 'rgb(0, 0, 0)',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-684">
                      <picture style={{
                      backgroundColor: 'rgb(164, 164, 165)',
                      height: '407px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      paddingTop: '407px',
                      position: 'relative',
                      width: '740px'
                    }} data-id="element-685">
                        <source srcSet="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:1025px)" style={{}} data-id="element-686"></source>
                        <source srcSet="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=740&height=410&rmode=crop&scale=crop&quality=90" media="(min-width:768px)" style={{}} data-id="element-687"></source>
                        <source srcSet="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=767&height=425&rmode=crop&scale=crop&quality=90" media="(min-width:481px)" style={{}} data-id="element-688"></source>
                        <img src="/49cb96/globalassets/03.-property-pages/rome/00-images/04-cowork/3.-room-listing/the-social-hub_rome_dedicated_des_scrivanie.jpg?width=315&height=175&rmode=crop&scale=crop&quality=90" alt="" style={{
                        height: '407px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-689"></img>
                        <span style={{
                        display: 'block',
                        minHeight: '0px',
                        minWidth: '0px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        height: '407px',
                        overflowX: 'visible',
                        overflowY: 'visible',
                        paddingTop: '0px',
                        position: 'absolute',
                        width: '740px'
                      }} data-id="element-690"></span>
                      </picture>
                      <h2 style={{
                      fontWeight: '800',
                      lineHeight: '50px',
                      fontSize: '40px',
                      bottom: '35px',
                      color: 'rgb(255, 255, 255)',
                      left: '65px',
                      position: 'absolute',
                      margin: '0px'
                    }} data-id="element-691">
                        Scrivania dedicata
                      </h2>
                    </div>
                    <div style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(255, 255, 255)',
                    color: 'rgb(0, 0, 0)',
                    fontSize: '18px',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    position: 'relative',
                    width: '740px',
                    content: 'normal',
                    display: 'block',
                    height: '507px',
                    left: '0px',
                    top: '0px',
                    transform: 'none',
                    zIndex: 'auto',
                    transitionBehavior: 'normal, normal',
                    transitionDuration: '0.2s, 0.2s',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    transitionDelay: '0s, 0s',
                    transitionProperty: 'background-color, border-color',
                    borderLeft: '1px solid rgb(164, 164, 165)',
                    borderRight: '1px solid rgb(164, 164, 165)',
                    borderBottom: '1px solid rgb(164, 164, 165)',
                    padding: '40px 65px 30px 65px',
                    margin: '0px'
                  }} data-id="element-692">
                      <span style={{
                      backgroundColor: 'rgb(0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      fontSize: '18px',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      position: 'absolute',
                      width: '30px',
                      content: '" "',
                      display: 'block',
                      height: '30px',
                      left: '54px',
                      top: '-15px',
                      transform: 'matrix(0.744165, 0.670049, -0.744165, 0.670049, 0, 0)',
                      zIndex: '1',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'all',
                      borderLeft: '0px none rgb(0, 0, 0)',
                      borderRight: '0px none rgb(0, 0, 0)',
                      borderBottom: '0px none rgb(0, 0, 0)',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-693"></span>
                      <p style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '22px',
                      lineHeight: '33px',
                      padding: '0px',
                      margin: '0px 0px 20px 0px'
                    }} data-id="element-694">
                        Hai bisogno di uno spazio tutto per te? Sfrutta i
                        vantaggi di una scrivania fissa e una sedia ergonomica
                        con la nostra scrivania dedicata, estendendo la tua
                        Membership. Personalizza il tuo ambiente di lavoro in
                        base alle tue esigenze.
                      </p>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexWrap: 'wrap',
                      borderBottom: '1px solid rgb(0, 0, 0)',
                      padding: '0px 0px 20px 0px',
                      margin: '0px 0px 30px 0px'
                    }} data-id="element-695">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-696">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-697" />
                          <span style={{}} data-id="element-698">Accesso 24h/7</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-699">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-700" />
                          <span style={{}} data-id="element-701">
                            Scrivania, sedia ergonomica e armadietto
                          </span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-702">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-703" />
                          <span style={{}} data-id="element-704">Armadietto privato</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-705">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-706" />
                          <span style={{}} data-id="element-707">Servizio postale</span>
                        </div>
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '18px',
                        lineHeight: '35px',
                        width: '304px',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-708">
                          <CheckIcon style={{
                          height: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          marginRight: '15px',
                          minWidth: '24px',
                          maxWidth: '24px'
                        }} data-id="element-709" />
                          <span style={{}} data-id="element-710">Arricchisci il tuo abbonamento</span>
                        </div>
                      </div>
                      <div style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '0px',
                      margin: '0px'
                    }} data-id="element-711">
                        <div style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        display: 'flex',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-712">
                          <div style={{
                          boxSizing: 'border-box',
                          padding: '0px',
                          margin: '0px'
                        }} data-id="element-713"></div>
                        </div>
                        <a href="/it/forms/co-working/pacchetti/" style={{
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        color: 'rgb(0, 0, 0)',
                        maxWidth: 'none',
                        minWidth: '0px',
                        outlineColor: 'rgb(0, 0, 0)',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                        border: '1px solid rgb(0, 0, 0)',
                        padding: '13px 30px 13px 30px',
                        margin: '0px 0px 0px 355.297px'
                      }} data-id="element-714">
                          <span style={{
                          lineHeight: '24px',
                          color: 'rgb(0, 0, 0)',
                          fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                          fontSize: '20px',
                          marginBottom: '0px',
                          textOverflow: 'ellipsis',
                          width: '190.703px'
                        }} data-id="element-715">
                            Richiedi informazioni
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span aria-live="assertive" aria-atomic="true" style={{}} data-id="element-716"></span>
            </div>
            <button type="button" style={{
            fontFamily: 'SharpGroteskMedium, Arial, Verdana',
            backgroundColor: 'rgb(0, 0, 0)',
            color: 'rgb(255, 255, 255)',
            outlineColor: 'rgb(255, 255, 255)',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '100px',
            justifyContent: 'center',
            transitionBehavior: 'normal',
            transitionDuration: '0.25s',
            transitionTimingFunction: 'ease-in',
            transitionDelay: '0s',
            transitionProperty: 'opacity',
            width: '100px',
            position: 'absolute',
            top: '440.5px',
            zIndex: '1',
            left: '5px',
            right: '940px',
            border: '0px none rgb(255, 255, 255)',
            borderRadius: '50%',
            padding: '0px',
            margin: '0px 233.5px 0px 233.5px'
          }} data-id="element-717">
              <ChevronLeftIcon style={{
              height: '48px',
              width: '50px',
              fill: 'rgb(255, 255, 255)'
            }} data-id="element-718" />
            </button>
            <button type="button" style={{
            fontFamily: 'SharpGroteskMedium, Arial, Verdana',
            backgroundColor: 'rgb(0, 0, 0)',
            color: 'rgb(255, 255, 255)',
            outlineColor: 'rgb(255, 255, 255)',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '100px',
            justifyContent: 'center',
            transitionBehavior: 'normal',
            transitionDuration: '0.25s',
            transitionTimingFunction: 'ease-in',
            transitionDelay: '0s',
            transitionProperty: 'opacity',
            width: '100px',
            position: 'absolute',
            top: '440.5px',
            zIndex: '1',
            left: '940px',
            right: '5px',
            border: '0px none rgb(255, 255, 255)',
            borderRadius: '50%',
            padding: '0px',
            margin: '0px 233.5px 0px 233.5px'
          }} data-id="element-719">
              <ChevronRightIcon style={{
              height: '48px',
              width: '50px',
              fill: 'rgb(255, 255, 255)'
            }} data-id="element-720" />
            </button>
          </section>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-721">
          <section style={{
          backgroundColor: 'rgb(255, 221, 0)',
          color: 'rgb(0, 0, 0)',
          marginBottom: '110px',
          paddingLeft: '30px',
          paddingRight: '30px',
          paddingTop: '55px',
          textAlign: 'center'
        }} data-id="element-722">
            <div style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            padding: '0px',
            margin: '0px -10px 0px -10px'
          }} data-id="element-723">
              <div style={{
              boxSizing: 'border-box',
              position: 'relative',
              width: '736px',
              flexGrow: '0',
              flexShrink: '0',
              flexBasis: '50%',
              maxWidth: '50%',
              padding: '0px 10px 0px 10px',
              margin: '0px 0px 0px 368px'
            }} data-id="element-724">
                <h2 style={{
                fontWeight: '400',
                lineHeight: '50px',
                fontSize: '40px',
                margin: '0px 0px 20px 0px'
              }} data-id="element-725">
                  Partecipa a un tour personale
                </h2>
                <p style={{
                color: 'rgb(0, 0, 0)',
                fontSize: '18px',
                lineHeight: '27px',
                padding: '10px 0px 0px 0px',
                margin: '0px'
              }} data-id="element-726">
                  Per prenotare un tour dello spazio di coworking The Social
                  Hub, basta cliccare sul pulsante qui sotto.
                </p>
                <a href="/it/campaign/prenota-tour-co-working/" style={{
                backgroundColor: 'rgb(0, 0, 0)',
                color: 'rgb(255, 255, 255)',
                maxWidth: '500px',
                minWidth: '290px',
                outlineColor: 'rgb(255, 255, 255)',
                display: 'inline-flex',
                textAlign: 'left',
                top: '30px',
                border: '0px none rgb(255, 255, 255)',
                padding: '13px 80px 13px 30px',
                margin: '0px'
              }} data-id="element-727">
                  <span style={{
                  lineHeight: '24px',
                  color: 'rgb(255, 255, 255)',
                  fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                  fontSize: '20px',
                  marginBottom: '0px',
                  textOverflow: 'ellipsis',
                  width: '165.727px'
                }} data-id="element-728">
                    Prenota il tuo tour
                  </span>
                  <span style={{
                  alignItems: 'center',
                  display: 'flex',
                  height: '32px',
                  justifyContent: 'center',
                  position: 'absolute',
                  right: '0px',
                  top: '30px',
                  transform: 'matrix(1, 0, 0, 1, -30, -16)',
                  transitionBehavior: 'normal',
                  transitionDuration: '0.1s',
                  transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  transitionDelay: '0s',
                  transitionProperty: 'transform',
                  width: '32px'
                }} data-id="element-729">
                    <ArrowIcon style={{
                    height: '32px',
                    width: '32px',
                    fill: 'rgb(255, 255, 255)'
                  }} data-id="element-730" />
                  </span>
                </a>
              </div>
            </div>
          </section>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-731">
          <section style={{
          marginBottom: '80px',
          paddingLeft: '0px',
          paddingRight: '0px'
        }} data-id="element-732">
            <div style={{
            boxSizing: 'border-box',
            width: '1280px',
            maxWidth: '1280px',
            padding: '0px 80px 0px 80px',
            margin: '0px 116px 0px 116px'
          }} data-id="element-733">
              <div style={{
              boxSizing: 'border-box',
              display: 'flex',
              flexWrap: 'wrap',
              padding: '0px',
              margin: '0px -10px 0px -10px'
            }} data-id="element-734">
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                width: '950px',
                flexGrow: '0',
                flexShrink: '0',
                flexBasis: '83.3333%',
                maxWidth: '83.3333%',
                padding: '0px 10px 0px 10px',
                margin: '0px 0px 0px 95px'
              }} data-id="element-735">
                  <section style={{
                  marginBottom: '0px',
                  overflowX: 'auto'
                }} data-id="element-736">
                    <h3 style={{
                    lineHeight: '40px',
                    fontSize: '32px',
                    letterSpacing: '-0.2px'
                  }} data-id="element-737">
                      Cosa è incluso?
                    </h3>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-738">
          <div style={{
          boxSizing: 'border-box',
          padding: '0px',
          margin: '0px'
        }} data-id="element-739">
            <style style={{
            boxSizing: 'border-box'
          }} data-id="element-740">
              {`
        .customMultiColumnTable table &#123;
            margin: 40px auto 120px auto;
            max-width: 900px;
            overflow-y: auto;
        &#125;
        .customMultiColumnTable thead th &#123;
            position: sticky;
            top: 120px;
        &#125;
        @supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) &#123;
            .customMultiColumnTable thead th &#123;
                position: inherit;
            &#125;
        &#125;
        @media only screen and (max-width: 1024px) &#123;
            .customMultiColumnTable thead th &#123;
                top: 48px;
            &#125;
        &#125;
        .customMultiColumnTable th &#123;
            background: #66afff !important;
            padding-right: 0 !important;
            border-bottom: .1rem solid #000;
            line-height: 1.5;
            padding-top: 4rem !important;
        &#125;
        .customMultiColumnTable th:nth-of-type(2) &#123;
            width: 110px;
        &#125;
        .customMultiColumnTable th:first-of-type &#123;
            padding-left: 2rem !important;
        &#125;
        .customMultiColumnTable th &#123;
            padding-right: 2rem !important;
        &#125;
        .customMultiColumnTable th:last-of-type &#123;
            padding-right: 1rem !important;
        &#125;
        .customMultiColumnTable td &#123;
            padding: 2.5rem 1rem !important;
            border-top: 0 !important;
        &#125;
        .customMultiColumnTable tr:nth-child(odd) &#123;
            padding-right: 0 !important;
            background: #007aff10 !important;
            /*background: #66BF8A10 !important;*/
        &#125;
        .customMultiColumnTable .infoCol &#123;
            color: #67686a;
        &#125;
	`}
            </style>
            <div style={{
            boxSizing: 'border-box',
            padding: '0px',
            margin: '0px'
          }} data-id="element-741">
              <table style={{
              maxWidth: '900px',
              overflowY: 'visible',
              boxSizing: 'border-box',
              borderCollapse: 'collapse',
              width: '900px',
              border: '0px none rgb(0, 0, 0)',
              margin: '40px 306px 120px 306px'
            }} data-id="element-742">
                <thead style={{
                boxSizing: 'border-box'
              }} data-id="element-743">
                  <tr style={{
                  backgroundColor: 'rgba(0, 122, 255, 0.063)',
                  fontSize: '18px',
                  color: 'rgb(0, 0, 0)',
                  fontFamily: 'Rubik, Arial, sans-serif',
                  fontWeight: '500',
                  letterSpacing: '0.3px',
                  borderTop: '0px none rgb(0, 0, 0)',
                  borderBottom: '0px none rgb(0, 0, 0)',
                  padding: '17px 0px 17px 10px'
                }} data-id="element-744">
                    <th style={{
                    padding: '40px 20px 21px 20px'
                  }} data-id="element-745">
                      {' '}
                    </th>
                    <th style={{
                    width: '144.117px',
                    padding: '40px 20px 21px 10px'
                  }} data-id="element-746">
                      Membership
                    </th>
                    <th style={{
                    padding: '40px 20px 21px 10px'
                  }} data-id="element-747">
                      Day Pass
                    </th>
                    <th style={{
                    padding: '40px 20px 21px 10px'
                  }} data-id="element-748">
                      Dedicated Desk
                    </th>
                    <th style={{
                    padding: '40px 10px 21px 10px'
                  }} data-id="element-749">
                      Private Office
                    </th>
                  </tr>
                </thead>
                <tbody style={{
                boxSizing: 'border-box'
              }} data-id="element-750">
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-751">
                    <td style={{}} data-id="element-752">24/7 home hub access</td>
                    <td style={{}} data-id="element-753">
                      <CheckIcon style={{}} data-id="element-754" />
                    </td>
                    <td style={{}} data-id="element-755">
                      <CheckIcon style={{}} data-id="element-756" />
                    </td>
                    <td style={{}} data-id="element-757">
                      <CheckIcon style={{}} data-id="element-758" />
                    </td>
                    <td style={{}} data-id="element-759">
                      <CheckIcon style={{}} data-id="element-760" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-761">
                    <td style={{}} data-id="element-762">All hub access</td>
                    <td style={{}} data-id="element-763">Add On</td>
                    <td style={{}} data-id="element-764">Add On</td>
                    <td style={{}} data-id="element-765">Add On</td>
                    <td style={{}} data-id="element-766">Add On</td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-767">
                    <td style={{}} data-id="element-768">
                      Access to flexible workspace, members lounge and social
                      spaces
                    </td>
                    <td style={{}} data-id="element-769">
                      <CheckIcon style={{}} data-id="element-770" />
                    </td>
                    <td style={{}} data-id="element-771">
                      <CheckIcon style={{}} data-id="element-772" />
                    </td>
                    <td style={{}} data-id="element-773">
                      <CheckIcon style={{}} data-id="element-774" />
                    </td>
                    <td style={{}} data-id="element-775">
                      <CheckIcon style={{}} data-id="element-776" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-777">
                    <td style={{}} data-id="element-778">24/7 use of fully equipped gym</td>
                    <td style={{}} data-id="element-779">
                      <CheckIcon style={{}} data-id="element-780" />
                    </td>
                    <td style={{}} data-id="element-781">
                      <CheckIcon style={{}} data-id="element-782" />
                    </td>
                    <td style={{}} data-id="element-783">
                      <CheckIcon style={{}} data-id="element-784" />
                    </td>
                    <td style={{}} data-id="element-785">
                      <CheckIcon style={{}} data-id="element-786" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-787">
                    <td style={{}} data-id="element-788">Daily group fitness classes</td>
                    <td style={{}} data-id="element-789">
                      <CheckIcon style={{}} data-id="element-790" />
                    </td>
                    <td style={{}} data-id="element-791">
                      <CheckIcon style={{}} data-id="element-792" />
                    </td>
                    <td style={{}} data-id="element-793">
                      <CheckIcon style={{}} data-id="element-794" />
                    </td>
                    <td style={{}} data-id="element-795">
                      <CheckIcon style={{}} data-id="element-796" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-797">
                    <td style={{}} data-id="element-798">Community dinners and lunches</td>
                    <td style={{}} data-id="element-799">
                      <CheckIcon style={{}} data-id="element-800" />
                    </td>
                    <td style={{}} data-id="element-801">-</td>
                    <td style={{}} data-id="element-802">
                      <CheckIcon style={{}} data-id="element-803" />
                    </td>
                    <td style={{}} data-id="element-804">
                      <CheckIcon style={{}} data-id="element-805" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-806">
                    <td style={{}} data-id="element-807">
                      Access to public and curated member events
                    </td>
                    <td style={{}} data-id="element-808">
                      <CheckIcon style={{}} data-id="element-809" />
                    </td>
                    <td style={{}} data-id="element-810">
                      <CheckIcon style={{}} data-id="element-811" />
                    </td>
                    <td style={{}} data-id="element-812">
                      <CheckIcon style={{}} data-id="element-813" />
                    </td>
                    <td style={{}} data-id="element-814">
                      <CheckIcon style={{}} data-id="element-815" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-816">
                    <td style={{}} data-id="element-817">Bring 1 guest per day</td>
                    <td style={{}} data-id="element-818">
                      <CheckIcon style={{}} data-id="element-819" />
                    </td>
                    <td style={{}} data-id="element-820">-</td>
                    <td style={{}} data-id="element-821">
                      <CheckIcon style={{}} data-id="element-822" />
                    </td>
                    <td style={{}} data-id="element-823">
                      <CheckIcon style={{}} data-id="element-824" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-825">
                    <td style={{}} data-id="element-826">Free coffee, tea and water</td>
                    <td style={{}} data-id="element-827">
                      <CheckIcon style={{}} data-id="element-828" />
                    </td>
                    <td style={{}} data-id="element-829">
                      <CheckIcon style={{}} data-id="element-830" />
                    </td>
                    <td style={{}} data-id="element-831">
                      <CheckIcon style={{}} data-id="element-832" />
                    </td>
                    <td style={{}} data-id="element-833">
                      <CheckIcon style={{}} data-id="element-834" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-835">
                    <td style={{}} data-id="element-836">10% discount at the restaurant and bar</td>
                    <td style={{}} data-id="element-837">
                      <CheckIcon style={{}} data-id="element-838" />
                    </td>
                    <td style={{}} data-id="element-839">-</td>
                    <td style={{}} data-id="element-840">
                      <CheckIcon style={{}} data-id="element-841" />
                    </td>
                    <td style={{}} data-id="element-842">
                      <CheckIcon style={{}} data-id="element-843" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-844">
                    <td style={{}} data-id="element-845">15% discount on hotel rooms</td>
                    <td style={{}} data-id="element-846">
                      <CheckIcon style={{}} data-id="element-847" />
                    </td>
                    <td style={{}} data-id="element-848">-</td>
                    <td style={{}} data-id="element-849">
                      <CheckIcon style={{}} data-id="element-850" />
                    </td>
                    <td style={{}} data-id="element-851">
                      <CheckIcon style={{}} data-id="element-852" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-853">
                    <td style={{}} data-id="element-854">10% discount at on-site shops</td>
                    <td style={{}} data-id="element-855">
                      <CheckIcon style={{}} data-id="element-856" />
                    </td>
                    <td style={{}} data-id="element-857">-</td>
                    <td style={{}} data-id="element-858">
                      <CheckIcon style={{}} data-id="element-859" />
                    </td>
                    <td style={{}} data-id="element-860">
                      <CheckIcon style={{}} data-id="element-861" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-862">
                    <td style={{}} data-id="element-863">Exclusive member rates on meeting rooms</td>
                    <td style={{}} data-id="element-864">
                      <CheckIcon style={{}} data-id="element-865" />
                    </td>
                    <td style={{}} data-id="element-866">-</td>
                    <td style={{}} data-id="element-867">
                      <CheckIcon style={{}} data-id="element-868" />
                    </td>
                    <td style={{}} data-id="element-869">
                      <CheckIcon style={{}} data-id="element-870" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-871">
                    <td style={{}} data-id="element-872">Mentoring opportunities</td>
                    <td style={{}} data-id="element-873">
                      <CheckIcon style={{}} data-id="element-874" />
                    </td>
                    <td style={{}} data-id="element-875">-</td>
                    <td style={{}} data-id="element-876">
                      <CheckIcon style={{}} data-id="element-877" />
                    </td>
                    <td style={{}} data-id="element-878">
                      <CheckIcon style={{}} data-id="element-879" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-880">
                    <td style={{}} data-id="element-881">Digital community (app access)</td>
                    <td style={{}} data-id="element-882">
                      <CheckIcon style={{}} data-id="element-883" />
                    </td>
                    <td style={{}} data-id="element-884">-</td>
                    <td style={{}} data-id="element-885">
                      <CheckIcon style={{}} data-id="element-886" />
                    </td>
                    <td style={{}} data-id="element-887">
                      <CheckIcon style={{}} data-id="element-888" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-889">
                    <td style={{}} data-id="element-890">Private locker</td>
                    <td style={{}} data-id="element-891"> </td>
                    <td style={{}} data-id="element-892">-</td>
                    <td style={{}} data-id="element-893">
                      <CheckIcon style={{}} data-id="element-894" />
                    </td>
                    <td style={{}} data-id="element-895"> </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-896">
                    <td style={{}} data-id="element-897">Your own desk and ergonomic chair</td>
                    <td style={{}} data-id="element-898"> </td>
                    <td style={{}} data-id="element-899">-</td>
                    <td style={{}} data-id="element-900">
                      <CheckIcon style={{}} data-id="element-901" />
                    </td>
                    <td style={{}} data-id="element-902">
                      <CheckIcon style={{}} data-id="element-903" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-904">
                    <td style={{}} data-id="element-905">A fully furnished office</td>
                    <td style={{}} data-id="element-906"> </td>
                    <td style={{}} data-id="element-907">-</td>
                    <td style={{}} data-id="element-908"> </td>
                    <td style={{}} data-id="element-909">
                      <CheckIcon style={{}} data-id="element-910" />
                    </td>
                  </tr>
                  <tr style={{
                  paddingRight: '0px',
                  backgroundColor: 'rgba(0, 122, 255, 0.063)'
                }} data-id="element-911">
                    <td style={{}} data-id="element-912">Use of address as your business address</td>
                    <td style={{}} data-id="element-913"> </td>
                    <td style={{}} data-id="element-914">-</td>
                    <td style={{}} data-id="element-915">
                      <CheckIcon style={{}} data-id="element-916" />
                    </td>
                    <td style={{}} data-id="element-917">
                      <CheckIcon style={{}} data-id="element-918" />
                    </td>
                  </tr>
                  <tr style={{}} data-id="element-919">
                    <td style={{}} data-id="element-920">Use of address for mail and packages</td>
                    <td style={{}} data-id="element-921"> </td>
                    <td style={{}} data-id="element-922">-</td>
                    <td style={{}} data-id="element-923">
                      <CheckIcon style={{}} data-id="element-924" />
                    </td>
                    <td style={{}} data-id="element-925">
                      <CheckIcon style={{}} data-id="element-926" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-927">
          <section style={{
          backgroundColor: 'rgb(102, 191, 138)',
          color: 'rgb(0, 0, 0)',
          marginBottom: '110px',
          paddingLeft: '30px',
          paddingRight: '30px',
          paddingTop: '55px',
          textAlign: 'center'
        }} data-id="element-928">
            <div style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            padding: '0px',
            margin: '0px -10px 0px -10px'
          }} data-id="element-929">
              <div style={{
              boxSizing: 'border-box',
              position: 'relative',
              width: '736px',
              flexGrow: '0',
              flexShrink: '0',
              flexBasis: '50%',
              maxWidth: '50%',
              padding: '0px 10px 0px 10px',
              margin: '0px 0px 0px 368px'
            }} data-id="element-930">
                <h2 style={{
                fontWeight: '400',
                lineHeight: '50px',
                fontSize: '40px',
                margin: '0px 0px 20px 0px'
              }} data-id="element-931">
                  Hai qualche domanda? Siamo qui per te.
                </h2>
                <p style={{
                color: 'rgb(0, 0, 0)',
                fontSize: '18px',
                lineHeight: '27px',
                padding: '10px 0px 0px 0px',
                margin: '0px'
              }} data-id="element-932">
                  Compila il modulo qui sotto e ti risponderemo il prima
                  possibile.
                </p>
                <a href="/it/forms/co-working/contact/" style={{
                backgroundColor: 'rgb(0, 0, 0)',
                color: 'rgb(255, 255, 255)',
                maxWidth: '500px',
                minWidth: '290px',
                outlineColor: 'rgb(255, 255, 255)',
                display: 'inline-flex',
                textAlign: 'left',
                top: '30px',
                border: '0px none rgb(255, 255, 255)',
                padding: '13px 80px 13px 30px',
                margin: '0px'
              }} data-id="element-933">
                  <span style={{
                  lineHeight: '24px',
                  color: 'rgb(255, 255, 255)',
                  fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                  fontSize: '20px',
                  marginBottom: '0px',
                  textOverflow: 'ellipsis',
                  width: '220.203px'
                }} data-id="element-934">
                    Contatta The Social Hub
                  </span>
                  <span style={{
                  alignItems: 'center',
                  display: 'flex',
                  height: '32px',
                  justifyContent: 'center',
                  position: 'absolute',
                  right: '0px',
                  top: '30px',
                  transform: 'matrix(1, 0, 0, 1, -30, -16)',
                  transitionBehavior: 'normal',
                  transitionDuration: '0.1s',
                  transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  transitionDelay: '0s',
                  transitionProperty: 'transform',
                  width: '32px'
                }} data-id="element-935">
                    <ArrowIcon style={{
                    height: '32px',
                    width: '32px',
                    fill: 'rgb(255, 255, 255)'
                  }} data-id="element-936" />
                  </span>
                </a>
              </div>
            </div>
          </section>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-937">
          <section style={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '80px',
          position: 'relative',
          zIndex: '1',
          height: '600px',
          width: '1512px'
        }} data-id="element-938">
            <div style={{
            boxSizing: 'border-box',
            width: '1280px',
            maxWidth: '1280px',
            padding: '0px 80px 0px 80px',
            margin: '0px 116px 0px 116px'
          }} data-id="element-939">
              <div style={{
              boxSizing: 'border-box',
              alignItems: 'center',
              cursor: 'pointer',
              display: 'flex',
              position: 'relative',
              padding: '0px',
              margin: '0px'
            }} data-id="element-940">
                <div style={{
                boxSizing: 'border-box',
                alignItems: 'center',
                display: 'flex',
                height: '600px',
                position: 'absolute',
                width: '224px',
                zIndex: '10',
                top: '0px',
                left: '0px',
                padding: '0px',
                margin: '0px'
              }} data-id="element-941">
                  <button type="button" style={{
                  fontFamily: 'Rubik, Arial, sans-serif',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                  color: 'rgb(0, 0, 0)',
                  outlineColor: 'rgb(0, 0, 0)',
                  display: 'block',
                  height: '50px',
                  opacity: '0',
                  position: 'absolute',
                  transitionBehavior: 'normal, normal',
                  transitionDuration: '0.2s, 0.2s',
                  transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  transitionDelay: '0s, 0s',
                  transitionProperty: 'opacity, transform',
                  width: '50px',
                  zIndex: '2',
                  left: '6.71875px',
                  transform: 'matrix(-1, 0, 0, -1, 0, 0)',
                  border: '0px none rgb(0, 0, 0)',
                  padding: '0px',
                  margin: '10px'
                }} data-id="element-942">
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'block',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-943">
                      <ChevronLeftIcon style={{}} data-id="element-944" />
                      <span style={{
                      clip: 'rect(1px, 1px, 1px, 1px)',
                      height: '1px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      position: 'absolute',
                      whiteSpaceCollapse: 'collapse',
                      textWrapMode: 'nowrap',
                      width: '1px'
                    }} data-id="element-945">
                        Precedente
                      </span>
                    </div>
                    <span style={{
                    fontSize: '10px',
                    lineHeight: '11.5px',
                    overflowX: 'visible',
                    overflowY: 'visible',
                    textTransform: 'none',
                    appearance: 'none',
                    backgroundImage: 'radial-gradient(circle, rgb(0, 0, 0) -40%, rgba(0, 0, 0, 0) 55%)',
                    backgroundPositionX: '0%',
                    backgroundPositionY: '0%',
                    backgroundSize: 'auto',
                    backgroundRepeat: 'repeat',
                    backgroundAttachment: 'scroll',
                    backgroundOrigin: 'padding-box',
                    backgroundClip: 'border-box',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    color: 'rgb(0, 0, 0)',
                    fontStyle: 'normal',
                    fontVariantEmoji: 'normal',
                    fontWeight: '400',
                    fontStretch: '100%',
                    fontSizeAdjust: 'none',
                    outlineColor: 'rgb(0, 0, 0)',
                    outlineStyle: 'none',
                    outlineWidth: '0px',
                    display: 'block',
                    height: '80px',
                    position: 'absolute',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    width: '80px',
                    zIndex: '-1',
                    left: '-15px',
                    transform: 'none',
                    border: '0px none rgb(0, 0, 0)',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-946"></span>
                  </button>
                </div>
                <div style={{
                boxSizing: 'border-box',
                alignItems: 'center',
                display: 'flex',
                height: '600px',
                position: 'absolute',
                width: '224px',
                zIndex: '10',
                top: '0px',
                right: '0px',
                padding: '0px',
                margin: '0px'
              }} data-id="element-947">
                  <button type="button" style={{
                  fontFamily: 'Rubik, Arial, sans-serif',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                  color: 'rgb(0, 0, 0)',
                  outlineColor: 'rgb(0, 0, 0)',
                  display: 'block',
                  height: '50px',
                  opacity: '0',
                  position: 'absolute',
                  transitionBehavior: 'normal, normal',
                  transitionDuration: '0.2s, 0.2s',
                  transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94), cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  transitionDelay: '0s, 0s',
                  transitionProperty: 'opacity, transform',
                  width: '50px',
                  zIndex: '2',
                  right: '6.71875px',
                  border: '0px none rgb(0, 0, 0)',
                  padding: '0px',
                  margin: '10px'
                }} data-id="element-948">
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'block',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-949">
                      <ChevronRightIcon style={{}} data-id="element-950" />
                      <span style={{
                      clip: 'rect(1px, 1px, 1px, 1px)',
                      height: '1px',
                      overflowX: 'hidden',
                      overflowY: 'hidden',
                      position: 'absolute',
                      whiteSpaceCollapse: 'collapse',
                      textWrapMode: 'nowrap',
                      width: '1px'
                    }} data-id="element-951">
                        Successivo
                      </span>
                    </div>
                    <span style={{
                    fontSize: '10px',
                    lineHeight: '11.5px',
                    overflowX: 'visible',
                    overflowY: 'visible',
                    textTransform: 'none',
                    appearance: 'none',
                    backgroundImage: 'radial-gradient(circle, rgb(0, 0, 0) -40%, rgba(0, 0, 0, 0) 55%)',
                    backgroundPositionX: '0%',
                    backgroundPositionY: '0%',
                    backgroundSize: 'auto',
                    backgroundRepeat: 'repeat',
                    backgroundAttachment: 'scroll',
                    backgroundOrigin: 'padding-box',
                    backgroundClip: 'border-box',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    color: 'rgb(0, 0, 0)',
                    fontStyle: 'normal',
                    fontVariantEmoji: 'normal',
                    fontWeight: '400',
                    fontStretch: '100%',
                    fontSizeAdjust: 'none',
                    outlineColor: 'rgb(0, 0, 0)',
                    outlineStyle: 'none',
                    outlineWidth: '0px',
                    display: 'block',
                    height: '80px',
                    position: 'absolute',
                    transitionBehavior: 'normal',
                    transitionDuration: '0s',
                    transitionTimingFunction: 'ease',
                    transitionDelay: '0s',
                    transitionProperty: 'all',
                    width: '80px',
                    zIndex: '-1',
                    right: '-15px',
                    border: '0px none rgb(0, 0, 0)',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-952"></span>
                  </button>
                </div>
                <div style={{
                boxSizing: 'border-box',
                position: 'relative',
                overflowX: 'hidden',
                overflowY: 'hidden',
                listStylePosition: 'outside',
                listStyleImage: 'none',
                listStyleType: 'none',
                zIndex: '1',
                width: '1120px',
                padding: '0px',
                margin: '0px'
              }} data-id="element-953">
                  <div style={{
                  boxSizing: 'content-box',
                  position: 'relative',
                  width: '1120px',
                  height: '600px',
                  zIndex: '1',
                  display: 'flex',
                  transitionProperty: 'transform',
                  transform: 'matrix(1, 0, 0, 1, -13433, 0)',
                  transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
                  transitionDuration: '0s',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-954">
                    <div style={{
                    boxSizing: 'border-box',
                    flexShrink: '0',
                    width: '896px',
                    height: '600px',
                    position: 'relative',
                    transitionProperty: 'transform',
                    maxWidth: '900px',
                    padding: '0px',
                    margin: '0px 20px 0px 0px'
                  }} data-id="element-955">
                      <picture style={{
                      height: '600px',
                      paddingTop: '0px',
                      position: 'relative'
                    }} data-id="element-956">
                        <source srcSet="https://www.thesocialhub.co/49c308/globalassets/03.-property-pages/rome/00-images/rome--shared-images/the-social-hub_outside_rome_600x900.jpg?width=1280&height=720&rmode=max&scale=both&quality=90" media="(min-width:1025px)" style={{}} data-id="element-957"></source>
                        <source srcSet="https://www.thesocialhub.co/49c308/globalassets/03.-property-pages/rome/00-images/rome--shared-images/the-social-hub_outside_rome_600x900.jpg?width=1024&height=576&rmode=max&scale=both&quality=90" media="(min-width:768px)" style={{}} data-id="element-958"></source>
                        <source srcSet="https://www.thesocialhub.co/49c308/globalassets/03.-property-pages/rome/00-images/rome--shared-images/the-social-hub_outside_rome_600x900.jpg?width=767&height=431&rmode=max&scale=both&quality=90" media="(min-width:481px)" style={{}} data-id="element-959"></source>
                        <img src="https://www.thesocialhub.co/49c308/globalassets/03.-property-pages/rome/00-images/rome--shared-images/the-social-hub_outside_rome_600x900.jpg?width=480&height=270&rmode=max&scale=both&quality=90" alt="" style={{
                        height: '600px',
                        width: '896px',
                        position: 'static'
                      }} data-id="element-960"></img>
                      </picture>
                      <div style={{
                      boxSizing: 'border-box',
                      color: 'rgb(255, 255, 255)',
                      display: 'block',
                      fontSize: '14px',
                      opacity: '0',
                      transitionBehavior: 'normal',
                      transitionDuration: '0.25s',
                      transitionTimingFunction: 'ease-in',
                      transitionDelay: '0s',
                      transitionProperty: 'opacity',
                      bottom: '0px',
                      left: '0px',
                      position: 'absolute',
                      width: '896px',
                      zIndex: '1',
                      padding: '0px 0px 20px 20px',
                      margin: '0px'
                    }} data-id="element-961">
                        <span style={{
                        color: 'rgb(255, 255, 255)',
                        display: 'block',
                        fontSize: '14px',
                        transitionBehavior: 'normal',
                        transitionDuration: '0s',
                        transitionTimingFunction: 'ease',
                        transitionDelay: '0s',
                        transitionProperty: 'all',
                        bottom: '0px',
                        left: '0px',
                        position: 'absolute',
                        width: '896px',
                        zIndex: '-1',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-962"></span>
                      </div>
                    </div>
                    {/* Remaining gallery items omitted for brevity */}
                  </div>
                  <span aria-live="assertive" aria-atomic="true" style={{}} data-id="element-963"></span>
                </div>
              </div>
              <div style={{
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              padding: '40px',
              margin: '-20px 0px 0px 0px'
            }} data-id="element-964">
                <div style={{
                boxSizing: 'border-box',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                padding: '0px',
                margin: '0px'
              }} data-id="element-965">
                  <div style={{
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  justifyItems: 'center',
                  overflowX: 'hidden',
                  overflowY: 'hidden',
                  transitionBehavior: 'normal',
                  transitionDuration: '0s',
                  transitionTimingFunction: 'ease',
                  transitionDelay: '0s',
                  transitionProperty: 'none',
                  width: '140px',
                  padding: '0px',
                  margin: '0px'
                }} data-id="element-966">
                    <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    padding: '0px',
                    margin: '0px'
                  }} data-id="element-967">
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0.25s',
                      transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                      transitionDelay: '0s',
                      transitionProperty: 'transform',
                      transform: 'matrix(0.5, 0, 0, 0.5, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-968">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-969"></div>
                      </button>
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'none',
                      transform: 'matrix(0.5, 0, 0, 0.5, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-970">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-971"></div>
                      </button>
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'none',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-972">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-973"></div>
                      </button>
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'none',
                      transform: 'matrix(1.5, 0, 0, 1.5, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-974">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-975"></div>
                      </button>
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'none',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-976">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-977"></div>
                      </button>
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0s',
                      transitionTimingFunction: 'ease',
                      transitionDelay: '0s',
                      transitionProperty: 'none',
                      transform: 'matrix(0.5, 0, 0, 0.5, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-978">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-979"></div>
                      </button>
                      <button type="button" style={{
                      fontFamily: 'Rubik, Arial, sans-serif',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      color: 'rgb(0, 0, 0)',
                      outlineColor: 'rgb(0, 0, 0)',
                      display: 'block',
                      transitionBehavior: 'normal',
                      transitionDuration: '0.25s',
                      transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                      transitionDelay: '0s',
                      transitionProperty: 'transform',
                      transform: 'matrix(0.5, 0, 0, 0.5, 0, 0)',
                      border: '0px none rgb(0, 0, 0)',
                      padding: '10px',
                      margin: '0px'
                    }} data-id="element-980">
                        <div style={{
                        boxSizing: 'border-box',
                        height: '5px',
                        width: '5px',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: '50%',
                        padding: '0px',
                        margin: '0px'
                      }} data-id="element-981"></div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div style={{
        boxSizing: 'border-box',
        padding: '0px',
        margin: '0px'
      }} data-id="element-982">
          <section style={{
          backgroundColor: 'rgb(255, 235, 102)',
          color: 'rgb(0, 0, 0)',
          marginBottom: '110px',
          paddingLeft: '30px',
          paddingRight: '30px',
          paddingTop: '55px',
          textAlign: 'center'
        }} data-id="element-983">
            <div style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            padding: '0px',
            margin: '0px -10px 0px -10px'
          }} data-id="element-984">
              <div style={{
              boxSizing: 'border-box',
              position: 'relative',
              width: '736px',
              flexGrow: '0',
              flexShrink: '0',
              flexBasis: '50%',
              maxWidth: '50%',
              padding: '0px 10px 0px 10px',
              margin: '0px 0px 0px 368px'
            }} data-id="element-985">
                <h2 style={{
                fontWeight: '400',
                lineHeight: '50px',
                fontSize: '40px',
                margin: '0px 0px 20px 0px'
              }} data-id="element-986">
                  Unisciti alla nostra comunità in crescita
                </h2>
                <p style={{
                color: 'rgb(0, 0, 0)',
                fontSize: '18px',
                lineHeight: '27px',
                padding: '10px 0px 0px 0px',
                margin: '0px'
              }} data-id="element-987">
                  Entra in contatto con persone come te a Rome. Usufruisci di
                  vantaggi esclusivi, accesso a spazi premium, palestra e corsi
                  all'avanguardia, programma di eventi curato e una vivace
                  comunità.
                </p>
                <a href="/it/forms/membership/pass-prova/" style={{
                backgroundColor: 'rgb(0, 0, 0)',
                color: 'rgb(255, 255, 255)',
                maxWidth: '500px',
                minWidth: '290px',
                outlineColor: 'rgb(255, 255, 255)',
                display: 'inline-flex',
                textAlign: 'left',
                top: '30px',
                border: '0px none rgb(255, 255, 255)',
                padding: '13px 80px 13px 30px',
                margin: '0px'
              }} data-id="element-988">
                  <span style={{
                  lineHeight: '24px',
                  color: 'rgb(255, 255, 255)',
                  fontFamily: 'SharpGroteskMedium, Arial, Verdana',
                  fontSize: '20px',
                  marginBottom: '0px',
                  textOverflow: 'ellipsis',
                  width: '239.367px'
                }} data-id="element-989">
                    Ottieni il tuo pass di prova
                  </span>
                  <span style={{
                  alignItems: 'center',
                  display: 'flex',
                  height: '32px',
                  justifyContent: 'center',
                  position: 'absolute',
                  right: '0px',
                  top: '30px',
                  transform: 'matrix(1, 0, 0, 1, -30, -16)',
                  transitionBehavior: 'normal',
                  transitionDuration: '0.1s',
                  transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  transitionDelay: '0s',
                  transitionProperty: 'transform',
                  width: '32px'
                }} data-id="element-990">
                    <ArrowIcon style={{
                    height: '32px',
                    width: '32px',
                    fill: 'rgb(255, 255, 255)'
                  }} data-id="element-991" />
                  </span>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>;
}